import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=66465aad&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=66465aad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66465aad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66465aad')) {
      api.createRecord('66465aad', component.options)
    } else {
      api.reload('66465aad', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=66465aad&scoped=true&", function () {
      api.rerender('66465aad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2R6z7Pyy3zMgI/JS/comp/DocBox.vue"
export default component.exports